// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__3S0Ux","navbar_left":"styles_navbar_left__+s0t0","navbar_left_domain":"styles_navbar_left_domain__dr-C2","navbar_btns":"styles_navbar_btns__2cTcO"};